import { updateAssignmentQuestions as updateAssignmentQuestionsAPI } from "../api";

export const updateAssignmentQuestionsAction = async (assignmentID, questions, setAssignment) => {
  const assignment = await updateAssignmentQuestionsAPI(assignmentID, questions);
  setAssignment(assignment.data);
};
